import React, { FC } from 'react'
import styled from 'styled-components'

import { lng } from '@ads/front-core/locales'
import { Text } from '../CssStyled'
import TotalMoneyIcon from './TotalMoney'
import AudiotekaIcon from './Audioteka'
import ExtradomIcon from './Extradom'
import DomodiIcon from './Domodi'
import WakacjeIcon from './Wakacje'
import SuperautoIcon from './Superauto'

const TrustedUs: FC = () => (
  <Container>
    <TitleWrapper>
      <Text>{lng('landing:theyTrustedUs')}:</Text>
    </TitleWrapper>

    <Icons>
      <TotalMoneyIcon />
      <AudiotekaIcon />
      <ExtradomIcon />
      <DomodiIcon />
      <WakacjeIcon />
      <SuperautoIcon />
    </Icons>
  </Container>
)

const Container = styled.div`
  position: absolute;
  bottom: -116px;
  left: 0;
  right: 0;
  padding: 20px;
  border-radius: 8px;
  background: #ffffff;
  box-shadow: 0px 4px 15px rgba(0, 0, 0, 0.15);
`

const TitleWrapper = styled.div`
  margin-bottom: 18px;
`

const Icons = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: flex-end;
  overflow-y: auto;

  svg {
    flex: none;
  }
`

export default TrustedUs
